import script from "./CommentCreation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentCreation.vue?vue&type=script&setup=true&lang=ts"

import "./CommentCreation.vue?vue&type=style&index=0&id=6a3e8a91&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3e8a91"]])

export default __exports__